import menu from './menu'
import theme from './theme'
import LeftPage from './LeftPage'
import account from './account'
import modals from './modals'


const reducers = {
    menu,
    theme,
    LeftPage,
    account,
    modals
};

export default reducers


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js